import React from "react";
import { useTranslation } from "react-i18next";
import { FileInput as BaseFileInput } from "@common/fileInput";
import { Props } from "./types";
import { Icon } from "./icon";
import styles from "./styles.scss";

function FileInput({ input }: Props) {
  const { t } = useTranslation();

  return (
    <label className={styles.fileInput}>
      <BaseFileInput
        className={styles.input}
        accepts={[
          "image/jpeg",
          "image/png",
          "image/gif",
          "image/bmp",
          "image/webp",
          "image/svg+xml",
          "image/tiff",
          "image/x-icon",
          "image/heif",
          "image/heic",
          "image/vnd.microsoft.icon",
          "image/x-ms-bmp",
          "image/avif",
          "image/jp2",
          "image/jxr",
        ]}
        input={input}
      />
      <Icon className={styles.icon} />
      <span>{t("common.upload")}</span>
    </label>
  );
}

export { FileInput };
